// The colourway swap ('product:swap') replaces the drop-a-hint modal with
// the new product's one, so the bindings re-run against the fresh nodes.
let productImage: HTMLImageElement | null = null;

const initDropAHint = () => {
  productImage = null;

  const dropHintModal = document.querySelector<HTMLFormElement>('#drop-a-hint-modal');

  if (!dropHintModal) {
    // console.debug('Drop-a-Hint form not found');
    return;
  }

  const recipientNameInput = dropHintModal.querySelector<HTMLInputElement>('input[name="recipientName"]');
  const yourNameInput = dropHintModal.querySelector<HTMLInputElement>('input[name="yourName"]');
  const recipientNameBlank = dropHintModal.querySelector<HTMLSpanElement>('.js-recipient-name');
  const yourNameBlank = dropHintModal.querySelector<HTMLSpanElement>('.js-your-name');
  productImage = dropHintModal.querySelector<HTMLImageElement>('.drop-a-hint__img');

  if (!recipientNameInput || !yourNameInput || !recipientNameBlank || !yourNameBlank || !productImage) {
    console.error('Drop-a-Hint form elements not found');
    return;
  }

  // Add event listeners

  // Keep the recipient name in sync with the input field
  recipientNameInput.addEventListener('input', () => {
    recipientNameBlank.textContent = recipientNameInput.value;
  });

  // Keep the your name in sync with the input field
  yourNameInput.addEventListener('input', () => {
    yourNameBlank.textContent = yourNameInput.value;
  });
};

document.addEventListener('DOMContentLoaded', initDropAHint);
document.addEventListener('product:swap', initDropAHint);

// Listen to the custom event to update the drop-a-hint image
// This is emitted in gallery.ts, when the Flickity gallery changes slide.
// Registered once — always targets the current modal's image element.
document.addEventListener('product:image-change', (event: CustomEvent) => {
  if (!productImage) return;
  const { image } = event.detail;
  console.debug('Product image has changed', image);
  // Setting data-src as well so it doesn't replace with placeholder on initial load
  productImage.setAttribute('data-src', image);
  productImage.setAttribute('src', image);
});
